<template>
    <footer class="footer text_11">
        <div class="row row--fullwidth flex-row footer__top">
            <div class="col lg-3">
                <div class="footer__logo">
                    <img v-lazy-load data-src="/img/logo-footer.png" v-lazy-load data-srcset="/img/logo-footer@2x.png 2x" alt="" />
                </div>
                <div class="footer__text">{{ $t("footer_text") }}</div>
            </div>
            <div class="col lg-2 border">
                <div class="menu">
                    <div class="menu__label">{{ $t("help") }}</div>
                    <ul class="menu__list">
                        <li class="menu__item">
                            <nuxt-link to="/dostavka/">{{ $t("help_delivery") }}</nuxt-link>
                        </li>
                        <li class="menu__item">
                            <nuxt-link to="/vozvrat/">{{ $t("return") }}</nuxt-link>
                        </li>
                        <li class="menu__item">
                            <nuxt-link to="/faq/">{{ $t("faq") }}</nuxt-link>
                        </li>
                        <li class="menu__item">
                            <nuxt-link to="/payment/">{{ $t("payment") }}</nuxt-link>
                        </li>
                        <li class="menu__item">
                            <nuxt-link to="/dokumenty/">{{ $t("docs") }}</nuxt-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col lg-3">
                <div class="menu">
                    <div class="menu__label">{{ $t("about") }}</div>
                    <ul class="menu__list">
                        <li class="menu__item">
                            <nuxt-link to="/lookbook/fw26-27/">{{ $t("lookbook-footer") }}</nuxt-link>
                        </li>
                        <li class="menu__item">
                            <nuxt-link to="/magaziny/">{{ $t("stores") }}</nuxt-link>
                        </li>
                        <li class="menu__item">
                            <nuxt-link to="/kontakty/">{{ $t("contacts") }}</nuxt-link>
                        </li>
                        <li class="menu__item">
                            <nuxt-link to="/vacancies/">{{ $t("vacancies") }}</nuxt-link>
                        </li>
                        <li class="menu__item">
                            <nuxt-link to="/agndr/">{{ $t("become_agndr") }}</nuxt-link>
                        </li>
                        <li class="menu__item">
                            <nuxt-link to="/loyalty-program/">{{ $t("pps_club_program") }}</nuxt-link>
                        </li>
                        <li class="menu__item">
                            <nuxt-link to="/gift-card">{{ $t("gift-certificates") }}</nuxt-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col lg-4 border">
                <div class="menu">
                    <div class="menu__label">{{ $t("contact_us") }}</div>
                    <ul class="menu__list">
                        <li
                            class="menu__item"
                            v-if="
                                $store.getters['globalvars/getShowContactPhone'] &&
                                $store.getters['globalvars/getLang'] &&
                                $store.getters['globalvars/getLang'] === 'ru'
                            ">
                            <a :href="'tel:' + $store.getters['globalvars/getContactPhone']">{{
                                $store.getters["globalvars/getContactPhone"]
                            }}</a>
                            <span class="color-text_3">9:00 - 21:00</span>
                        </li>
                        <li class="menu__item">
                            <a href="mailto:help@pps-office.com">help@pps-office.com</a>
                        </li>
                    </ul>
                </div>
                <SocialLinks type="messenger" />
            </div>
        </div>
        <div class="row row--fullwidth flex-row footer__bottom">
            <div class="col col--row lg-3">
                <nuxt-link to="/karta-saita" class="site-map">{{ $t("site_map") }}</nuxt-link>
            </div>
            <div class="col col--row lg-5 border flex-c">
                <SocialLinks />
                <nuxt-link to="/lk" class="flex-c footer__lk-link">
                    <svg-icon name="user--16" width="16" height="16"></svg-icon>
                    {{ $t("lk") }}
                </nuxt-link>
            </div>
            <div class="col col--row lg-4 border">
                <Subscribe target="basement" />
            </div>
        </div>
    </footer>
</template>
<script>
import SocialLinks from "./SocialLinks";
import Subscribe from "./Subscribe";
export default {
    name: "Footer",
    components: { SocialLinks, Subscribe },
};
</script>
<style scoped lang="less">
.footer {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 0;
    background: @bg;
    &__text {
        margin-top: 51px;
        text-align: justify;
    }
    &__lk-link {
        margin-left: auto;
        align-items: flex-end;
        gap: 4px;
    }
    &__logo {
        svg {
            max-width: 100%;
        }
    }
    &__top {
        .col {
            padding-top: 32px;
            padding-bottom: 90px;
        }
    }
    &__bottom {
        .col {
            padding-bottom: 32px;
            display: flex;
            align-items: flex-end;
        }
        .row {
            align-items: center;
        }
    }
    .col {
        &:first-child {
            padding-left: 64px;
        }
        &:last-child {
            padding-right: 64px;
        }
    }
    .border {
        border-left: 1px solid @border2;
    }
}

.menu {
    &__label {
        margin-bottom: 32px;
    }
    &__item {
        display: flex;
        & + & {
            margin-top: 16px;
        }
        a + span {
            margin-left: 16px;
        }
    }
    + .social {
        margin-top: 47px;
    }
}
</style>
